import React from "react"
import { NavLink } from "react-router-dom"

const getLocation = (address) => {
  if (!address) return "-"
  const parts = []
  if (address.address1) parts.push(address.address1)
  if (address.city) parts.push(address.city)
  return parts.length > 0 ? parts.join(", ") : "-"
}

function orEmpty(value) {
  return value || "-"
}

const StoreCard = ({ group }) => (
  <div className="analytics-layout-card">
    <span className="analytics-layout-card__title">Loja</span>
    <div className="analytics-layout-card__rows">
      <h6 className="analytics-layout-card__value">{orEmpty(group.name)}</h6>
      <h6 className="analytics-layout-card__value">{getLocation(group.address)}</h6>
      <h6 className="analytics-layout-card__value">{orEmpty(group.phone)}</h6>
    </div>
  </div>
)

const ResponsibleCard = ({ group }) => (
  <div className="analytics-layout-card">
    <span className="analytics-layout-card__title">Responsável</span>
    <div className="analytics-layout-card__rows">
      <h6 className="analytics-layout-card__value">{orEmpty(group.contact_name)}</h6>
      <h6 className="analytics-layout-card__value">{orEmpty(group.contact_phone)}</h6>
    </div>
  </div>
)

const PlayersCard = ({ group }) => (
  <div className="analytics-layout-card">
    <span className="analytics-layout-card__title">Jogadores</span>
    <h4 className="analytics-layout-card__big-number">
      {group.employees ? group.employees.length : 0}
    </h4>
  </div>
)

const AnalyticsLayout = props => {
  const { group, campaignUser, client } = props
  const baseUrl = "/analytics/" + group.id
  return (
    <>
      <div className="analytics-layout-cards">
        <StoreCard group={group} />
        <ResponsibleCard group={group} />
        <PlayersCard group={group} />
      </div>
      <nav className="contracts-layout-navigation">
        <NavLink
          exact
          to={baseUrl}
          activeClassName="contracts-layout-navigation-item-active"
          className="contracts-layout-navigation-item"
        >
          Jogadores
        </NavLink>
        <NavLink
          exact
          to={baseUrl + "/sales"}
          activeClassName="contracts-layout-navigation-item-active"
          className="contracts-layout-navigation-item"
        >
          Vendas
        </NavLink>
        <NavLink
          exact
          to={baseUrl + "/objectives"}
          activeClassName="contracts-layout-navigation-item-active"
          className="contracts-layout-navigation-item"
        >
          Objetivos
        </NavLink>
        {campaignUser.canSeeAnalytics && campaignUser.canSeeGDS && (
          <NavLink
            exact
            to={baseUrl + "/gds"}
            activeClassName="contracts-layout-navigation-item-active"
            className="contracts-layout-navigation-item"
          >
            {client.gds_tab_name ? client.gds_tab_name : 'Analiticas'}
          </NavLink>
        )}
      </nav>
      {props.children}
    </>
  )
}

export default AnalyticsLayout
